import chevronRight from "@ms/chevron_right.svg?raw";
import homeIcon from "@ms/home.svg?raw";
import { For, Show } from "solid-js";
import { Icon } from "./Icon";
import "./Breadcrumbs.css";

export type Breadcrumb = {
	label: string | Element;
	url: string | null;
	onClick?: () => void;
};

type Props = {
	breadCrumbs?: Breadcrumb[];
	showHomeIcon?: boolean;
	minItems?: number;
};

/**
 * Navigation breadcrumb trail showing hierarchical page path with optional home icon.
 *
 * [Design System →](http://localhost:5174/component/Navigation)
 */
export const Breadcrumbs = (props: Props) => {
	const breadCrumbs = () => props.breadCrumbs ?? [];
	const showHomeIcon = () => props.showHomeIcon ?? true;
	const minItems = () => props.minItems ?? 2;

	return (
		<Show when={breadCrumbs().length >= minItems()}>
			<nav class="breadcrumbs">
				<ol>
					<Show when={showHomeIcon()}>
						<li style="display:flex;">
							<Icon icon={homeIcon} />
						</li>
					</Show>
					<For each={breadCrumbs()}>
						{(item, index) => {
							const isLast = () => index() >= breadCrumbs().length - 1;
							const isLink = () => (item.url || item.onClick) && !isLast();
							return (
								<li>
									<Show
										when={isLink()}
										fallback={
											<div style="display:flex;">
												<div>{item.label}</div>
												<Show when={!isLast()}>
													<Icon icon={chevronRight} class="icon" />
												</Show>
											</div>
										}
									>
										<a
											style="display:flex;align-items:center;"
											href={item.url ?? "#"}
											onClick={(event) => {
												if (item.onClick) {
													event.preventDefault();
													item.onClick();
												}
											}}
										>
											<div>{item.label}</div>
											<Icon icon={chevronRight} class="icon" />
										</a>
									</Show>
								</li>
							);
						}}
					</For>
				</ol>
			</nav>
		</Show>
	);
};
